import { TRIVIA_INTERESTS } from 'constants/api'
import useAxios from 'axios-hooks'
import { MouseEventHandler, useContext, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import Button from 'components/button'
import { useSet } from 'react-use'
import { TextPref } from 'views/profile/text.style'
import toast from 'react-hot-toast'
import { useSession } from '../../contexts/session-context'
import { useTrivia } from '../../contexts/trivia-context'
import { LoaderContext } from '../../contexts/loader-context'
import { ButtonPref } from '../../theme/profile'

const PrefPicker = () => {
  const [activeItems, activeItemsSet] = useSet(new Set<number>([]))
  const [, { setInterests }] = useTrivia()
  const [{ data: session, user }] = useSession()
  const location = useLocation()
  const [state] = useTrivia()
  const { load, setLoad } = useContext(LoaderContext)
  const [{ error, loading, data }] = useAxios<{ id: number; name: string }[]>({
    url: TRIVIA_INTERESTS,
    headers: { Authorization: `Bearer ${((session as any)?._tokenResponse as any)?.idToken}` }
  })

  useEffect(() => {
    user?.interests.forEach(({ id }) => {
      activeItemsSet.add(id)
    })
  }, [user])

  useEffect(() => {
    setLoad(loading)
    return () => {
      setLoad(false)
    }
  }, [loading])

  const isProfile = location.pathname.endsWith('/profile/preferences')

  if (error) {
    return <pre>error.message</pre>
  }

  const handleOnClick: MouseEventHandler<HTMLButtonElement> = (event) => {
    event.persist()

    const { currentTarget } = event

    currentTarget.toggleAttribute('data-selected')

    const id = parseInt(currentTarget.getAttribute('data-interest-id') as string, 10)

    activeItemsSet.toggle(id)
  }

  const sendInterest = async () => {
    setLoad(true)
    try {
      gtag('event', 'Click', {
        event_category: GTM_EVENT_CATEGORY,
        event_label: 'INTERESES - Guardar mis intereses',
        value: '10'
      })
      await setInterests(Array.from(activeItems))
      toast.success('Los cambios se guardaron con éxito', { className: 'toast__success' })
    } catch (error) {
      toast.error('Ha ocurrido un error', { className: 'toast__error' })
    } finally {
      setLoad(false)
    }
  }

  if (load) {
    return <></>
  }

  const enableButton = activeItems.size < 3

  return (
    <div className={`flex-1 flex flex-col ${isProfile ? ' pb-8 pt-2 px-4 ' : ''}`}>
      <p className='text big text-left mb-6'>Saber tus preferencias nos ayuda a conocerte mejor ¡Siéntete libre de cambiarlas cuando quieras! </p>
      <div className="flex gap-4 flex-wrap items-start preferences__container">
        {!!data &&
          data.map((category) => {
            return (
              <ButtonPref
                handleOnClick={handleOnClick}
                isProfile={isProfile}
                state={state}
                category={category}
                datainterestid={category?.id}
                key={`interest-${category?.id}`}
              >
                <TextPref>{category?.name}</TextPref>
              </ButtonPref>
            )
          })}
      </div>
      <p className='text medium text-center mt-2 mb-8'>Selecciona y deselecciona para cambiar tus preferencias.</p>
      <Button
        disabled={enableButton}
        onClick={sendInterest}
        className={`pick-preference-button-go ${!enableButton ? 'pick-preference-button-go-enable' : ''} transition-colors`}
      >
        <p>{isProfile ? 'Guardar cambios' : 'Continuar'}</p>
      </Button>
    </div>
  )
}

export default PrefPicker
